export default class InvalidCustomAttributeOperationException extends Error {
  constructor(message: string) {
    super(message);
  }
}
